import {ApolloLink, Observable} from '@apollo/client';
import {getMainDefinition} from '@apollo/client/utilities';
import type {
  InternalOperation,
  unstable_InternalOperation as RevampInternalOperation,
} from '@sail/data';
import type {OperationDefinitionNode} from 'graphql';

import {
  getInteropAccountId,
  onInteropAccountIdSet,
} from '../../interopAccountId';
import type {InteropFields} from './RestLink/rewriteInteropParams';

function hasInteropField(
  interopFields: InteropFields,
  operation: InternalOperation | RevampInternalOperation,
): boolean {
  const definition = getMainDefinition(
    operation.query,
  ) as OperationDefinitionNode;
  const opType = definition.operation;

  return definition.selectionSet.selections.some((selection) => {
    if (selection.kind === 'Field') {
      return Boolean(interopFields[opType]?.[selection.name.value]);
    }
    return false;
  });
}

export default function createWaitForInteropAccountLink(
  interopFields: InteropFields,
) {
  return new ApolloLink(function waitForInteropAccountLink(
    operation: InternalOperation | RevampInternalOperation,
    forward,
  ) {
    if (!hasInteropField(interopFields, operation)) {
      return forward(operation);
    }

    const v1Context = operation.variables.v1Context as
      | {id?: string}
      | undefined;
    if (!v1Context?.id?.startsWith('org_')) {
      return forward(operation);
    }

    if (getInteropAccountId() !== null) {
      return forward(operation);
    }

    return new Observable((observer) => {
      onInteropAccountIdSet(() => {
        forward(operation).subscribe({
          next: (result) => observer.next(result),
          error: (error) => observer.error(error),
          complete: () => observer.complete(),
        });
      });
    });
  });
}
